import React from 'react';

interface Product {
    image: {src: string, srcMobile?: string}
    link: string;
    name: string;
    productNumber: number;
}

interface ExploreProductsProps {
    title: string;
    products: Product[];
}

export default function ExploreProducts({ title, products }: ExploreProductsProps) {
    return (
        <div className="explore-products">
            
            {title ? (
                <h2 className="explore-products__title">
                    {title}
                </h2>
            ) : <></>}

            <div className="explore-products__products">

            {products.map((product, index) => (
                <a key={index} href={product.link} className="explore-products__item">

                    <div className="explore-products__image-box">
                        <picture className="explore-products__picture">
                            <source media="(min-width: 1440px)" srcSet={product.image.src} />
                            <source media="(max-width: 767px)" srcSet={product.image.srcMobile} />
                            <img src={product.image.src} alt={product.name} className="explore-products__image" loading="lazy" />
                        </picture>
                    </div>

                    <div className="explore-products__content">
                        <p className="explore-products__name">{product.name}</p>
                        <p className="explore-products__number">Part number: {product.productNumber}</p>
                    </div>

                </a>
            ))}
            </div>
        </div>
    );
}
